import { render, staticRenderFns } from "./VoucherDetail.vue?vue&type=template&id=277fee4a"
import script from "./VoucherDetail.vue?vue&type=script&lang=js"
export * from "./VoucherDetail.vue?vue&type=script&lang=js"
import style0 from "./VoucherDetail.vue?vue&type=style&index=0&id=277fee4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports